export const CHANGE_FOREX_PORTAL = "CHANGE_FOREX_PORTAL";
